import fontColorContrast from 'font-color-contrast'
import React, { useEffect, useState } from 'react'
import { Col, Form, Row, Spinner } from 'react-bootstrap'
import { useForm } from "react-hook-form"
import axios from 'axios'
import FormRegister from './FormRegister'
import { checkList, fetchBlackList } from '../../../block-slider/utils'
const FormCheckEmail = ({ data, setUserInfo, query, pageData, setWarningMassage }) => {
    const {
        button_color,
        text_1,
        text_2,
        text_3,
        text_4,
        text_5,
        text_6,
        text_7,
        text_8,
        text_9,
        text_10,
        text_11 = 'Далее',
        text_12 = 'Email для добавление карты'
    } = data.setting

    const {
        register,
        handleSubmit,
        reset,
        control,
        setValue,
        formState: { errors, isValid },
    } = useForm({
        mode: 'onBlur'
    })

    const [isRegister, setIsRegister] = useState(false)
    const [registerData, setRegisterData] = useState(null)

    const [isLoading, setIsLoading] = useState(false); // загрузка при отправке

    const [blackList, setBlackList] = useState(null)
    useEffect(() => {
        fetchBlackList(10).then(res => {
            setBlackList(res)
        })
    }, [])

    const onSubmit = (formData) => {
        // const info = await fetchClientInfo()
        setIsLoading(true)
        axios
            .post(`${process.env.REACT_APP_API_BASE}/registration/check-email`, {
                email: formData.email
            })
            .then((response) => {
                // проверка зарегестрирован ли пользователь
                // res = true - значит пользователь новый
                // res = false - значит пользователь уже зарегестрирован
                if (response?.data && !response.data?.res) {
                    setIsRegister(true)
                    setRegisterData({
                        email: formData.email
                    })
                }
                else {
                    const warningText = data?.setting?.[response.data?.msgKey] || false
                    if (warningText) setWarningMassage(warningText)

                    setUserInfo({
                        email: formData.email
                    })
                }
            })
            .catch((err) => {
                console.log(err)
                // setIsAlertError(true)
                // setTextOnError('Что-то пошло не так')
            })
            .finally(() => {
                setIsLoading(false)
            });

    }

    return (
        isRegister ?
            <FormRegister formData={registerData} data={data} query={query} pageData={pageData} />
            :
            <Row className='justify-content-center'>
                <Col md={8} lg={8} xl={6} className='mb-2' >
                    {data.title && <div className='title' dangerouslySetInnerHTML={{ __html: data.title }} />}
                    <div className='light buildedPage-type_8-form' >
                        <div className='h5 mb-3' dangerouslySetInnerHTML={{ __html: text_12 }} />
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <Form.Control
                                className='mb-2'
                                placeholder={"E-mail"}
                                type="email"
                                {...register('email', {
                                    required: true,
                                    pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                                    validate: (value) => {
                                        return !checkList(blackList, value)
                                    },
                                    // pattern: /^((8|\+7)[\- ]?)?(\(?\d{3}\)?[\- ]?)?[\d\- ]{7,10}$/g
                                })}
                            />
                            <Form.Control.Feedback type="invalid" className='d-block' style={{ minHeight: 30 }}>
                                <>
                                    {
                                        errors?.email?.type === 'required' &&
                                        'Обязательно к заполнению'
                                    }
                                    {
                                        errors?.email?.type === 'pattern' && "E-mail заполнен некорректно "
                                    }

                                    {
                                        errors?.email?.type === "validate" &&
                                        (blackList?.text || "Недопустимое значение E-mail")
                                    }
                                </>
                            </Form.Control.Feedback>
                            <button
                                disabled={!isValid}
                                className='btn btn-submit'
                                type='submit'
                                style={{
                                    backgroundColor: button_color,
                                    color: fontColorContrast(button_color)
                                }}
                            >
                                {
                                    isLoading ?
                                        <Spinner animation='border' />
                                        :
                                        <div dangerouslySetInnerHTML={{ __html: text_11 || 'Далее' }}></div>
                                }
                            </button>
                        </form>
                    </div>
                </Col>
            </Row>

    )
}

export default FormCheckEmail